import type { FaireThemeEntity } from "../../entity_types/theme";

export const on_the_go_wellness_essentials: FaireThemeEntity = {
  token: "on-the-go-wellness-essentials",
  type: "theme",
  name: "On-the-Go Wellness Essentials",
  description: "Portable wellness staples -- compact, essential-oil-based items perfect for busy lifestyles.",
  teaser: "Travel-sized wellness your pop-up customers grab on impulse.",
  detail: "Your pop-up frequently stocks wellness products like healing salves and essential oils. Portable formats are ideal -- anchored by Immunity Spray, a 2oz travel-sized product with wholesale price under $10.",
  bgColor: "#D4EEF0",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_rcszdb9nmw",
    "p_4f86bbv4be",
    "p_8zkcdxa49m",
    "p_mb7pz63w34",
    "p_mna0e5vjkz",
    "p_kzf4azpurn",
    "p_59a373mwjb",
    "p_81zhmnckey",
    "p_eunmj5rq9y",
    "p_enhx2t322u",
    "p_5gay6r22jg",
    "p_6837yh7p55",
    "p_c7ew1m4vg5",
    "p_tzumkfxn68",
    "p_esult55j5a",
    "p_ug227p4fxr",
    "p_bpjeehghm7",
    "p_2kvw6k2z84",
    "p_3acv96vu7y",
    "p_sqvrgrf8vg",
    "p_v9vh5q5drf",
    "p_kgwh45nu49",
    "p_q47fsyeyjd",
    "p_axe7ab7zc4",
    "p_pbvthdvwp7",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
